import { action } from "mobx";
import { get, jsonParser, put } from "../utils/Client";

export const create = (store) => {
  return {
    user: null,
    status: null,
    initialDate: null,
    finalDate: null,

    report: action(() => get(
        `/payments/report?query=${store.queryField}` +
        `${store.user ? "&userId=" + store.user.id : ""}` +
        `${store.status ? "&status=" + store.status.value : ""}` +
        `${store.initialDate ? "&initialDate=" + store.initialDate : ""}` +
        `${store.finalDate ? "&finalDate=" + store.finalDate : ""}` +
        `&sort=${store.sort.column}` +
        `&order=${store.sort.ascending ? "ASC" : "DESC"}`
      )
    ),
  

    check: action(() =>
      get(`/payments/${store.selected[0].id}`)
        .then(jsonParser)
        .then((data) => {
          data["checked"] = !data["checked"];
          put(`/payments/${data.id}`, { body: data }).then(jsonParser);
        })
    ),

    query: action(() =>
      get(
        `/payments/advanced?query=${store.queryField}` +
          `${store.user ? "&userId=" + store.user.id : ""}` +
          `${store.status ? "&status=" + store.status.value : ""}` +
          `${store.initialDate ? "&initialDate=" + store.initialDate : ""}` +
          `${store.finalDate ? "&finalDate=" + store.finalDate : ""}` +
          `&all=${store.searchAll}` +
          `&size=${store.size}` +
          `&page=${store.page}` +
          `&sort=${store.sort.column}` +
          `&order=${store.sort.ascending ? "ASC" : "DESC"}`
      )
      .then(jsonParser)
      .then((data) => {
        store.page === 0
          ? (store.list = data.content)
          : store.list.push.apply(store.list, data.content);
        store.count = data.count;
        })
    ),
  };
};
